import React, { useContext } from 'react';
import { Button, Card, CardBody, CardHeader } from 'reactstrap';
import SimpleBar from 'simplebar-react';
import { DashboardContext } from '../../context/DashboardContext';
import moment from 'moment';
import 'moment/locale/fa';

const RecentContactMessage = () => {
  const { recentContactMessages } = useContext(DashboardContext);

  return (
    <React.Fragment>
      <div className="col-xl-4">
        <Card>
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">پیام‌های تماس اخیر</h4>
            <div className="flex-shrink-0">
              <Button color="soft-primary" size="sm">مشاهده همه</Button>
            </div>
          </CardHeader>
          <CardBody>
            <SimpleBar data-simplebar className="mx-n3 px-3" style={{ height: '375px' }}>
              <div className="vstack gap-3">
                {recentContactMessages.map((item, idx) => (
                  <div className="d-flex gap-3" key={idx}>
                    <div className="avatar-sm rounded flex-shrink-0 bg-primary-subtle text-primary d-flex align-items-center justify-content-center">
                      <i className="ri-user-2-fill fs-20"></i>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mb-2">
                        {item.senderName} <span className="text-muted">({item.email})</span>
                      </h6>
                      <p className="text-muted mb-1" title={item.message}>
                        {item.message.length > 100 ? item.message.substring(0, 100) + '...' : item.message}
                      </p>
                      <small className="text-muted">
                        {moment(item.createdAt).locale('fa').format('DD MMMM YYYY, HH:mm')}
                      </small>
                    </div>
                  </div>
                ))}
              </div>
            </SimpleBar>
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  );
};

export default RecentContactMessage;